// Botão "Reenviar e-mail de confirmação" (login, cadastro e link expirado).
// Sem `email`, mostra um campo para a pessoa digitar.

import React, { useEffect, useState } from 'react';
import { Alert, Button, Input, Space } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { reenviarConfirmacaoEmail } from '../../services/authService';

const ESPERA_SEGUNDOS = 60;

function ReenviarConfirmacao({ email: emailFixo = '', block = false }) {
  const [email, setEmail] = useState(emailFixo);
  const [enviando, setEnviando] = useState(false);
  const [enviadoPara, setEnviadoPara] = useState('');
  const [erro, setErro] = useState('');
  const [espera, setEspera] = useState(0);

  useEffect(() => { setEmail(emailFixo); }, [emailFixo]);

  useEffect(() => {
    if (espera <= 0) return undefined;
    const t = setTimeout(() => setEspera((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [espera]);

  const reenviar = async () => {
    const alvo = (email || '').trim();
    if (!alvo || !alvo.includes('@')) {
      setErro('Digite o e-mail que você usou no cadastro.');
      return;
    }
    setErro('');
    setEnviando(true);
    try {
      await reenviarConfirmacaoEmail(alvo);
      setEnviadoPara(alvo);
      setEspera(ESPERA_SEGUNDOS);
    } catch (err) {
      setErro(err?.response?.status === 429
        ? 'Muitas tentativas. Aguarde alguns minutos e tente de novo.'
        : 'Não foi possível reenviar agora. Tente de novo em instantes.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={{ textAlign: 'left' }}>
      {!emailFixo && (
        <Input
          prefix={<MailOutlined />}
          placeholder="E-mail do cadastro"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onPressEnter={reenviar}
          style={{ marginBottom: 8 }}
          size="large"
        />
      )}
      <Space direction="vertical" style={{ width: '100%' }}>
        <Button
          onClick={reenviar}
          loading={enviando}
          disabled={espera > 0}
          block={block || !emailFixo}
          size={emailFixo ? 'middle' : 'large'}
        >
          {espera > 0 ? `Reenviar de novo em ${espera}s` : 'Reenviar e-mail de confirmação'}
        </Button>
        {enviadoPara && (
          <Alert
            type="success"
            showIcon
            message={`Se houver um cadastro aguardando confirmação, enviamos um novo link para ${enviadoPara}.`}
            description="Confira também as pastas Spam e Promoções. O link novo vale por 7 dias."
          />
        )}
        {erro && <Alert type="error" showIcon message={erro} />}
      </Space>
    </div>
  );
}

export default ReenviarConfirmacao;
